import { ReportHandler } from 'web-vitals';
import mixpanel from 'mixpanel-browser';

const reportWebVitals = (onPerfEntry?: ReportHandler) => {
  if (onPerfEntry && onPerfEntry instanceof Function) {
    import('web-vitals').then(({ getCLS, getFID, getFCP, getLCP, getTTFB }) => {
      getCLS(onPerfEntry);
      getFID(onPerfEntry);
      getFCP(onPerfEntry);
      getLCP(onPerfEntry);
      getTTFB(onPerfEntry);
    });
  }

  // Send performance metrics to Mixpanel
  import('web-vitals').then(({ getCLS, getFID, getFCP, getLCP, getTTFB }) => {
    getCLS((metric) => {
      // Cumulative Layout Shift
      mixpanel.track('Web Vitals', { 
        metric: 'CLS', 
        value: metric.value,
        delta: metric.delta,
        id: metric.id,
        name: metric.name
      });
    });
    getFID((metric) => {
      // First Input Delay
      mixpanel.track('Web Vitals', { 
        metric: 'FID', 
        value: metric.value,
        delta: metric.delta,
        id: metric.id,
        name: metric.name
      });
    });
    getFCP((metric) => {
      // First Contentful Paint
      mixpanel.track('Web Vitals', { 
        metric: 'FCP', 
        value: metric.value,
        delta: metric.delta,
        id: metric.id,
        name: metric.name
      });
    });
    getLCP((metric) => {
      // Largest Contentful Paint
      mixpanel.track('Web Vitals', { 
        metric: 'LCP', 
        value: metric.value,
        delta: metric.delta,
        id: metric.id,
        name: metric.name
      });
    });
    getTTFB((metric) => {
      // Time to First Byte
      mixpanel.track('Web Vitals', { 
        metric: 'TTFB', 
        value: metric.value,
        delta: metric.delta,
        id: metric.id,
        name: metric.name
      });
    });
  });
};

export default reportWebVitals;
